import { createSlice } from '@reduxjs/toolkit';

// Initialize state from localStorage if available
const getInitialViewMode = () => {
  try {
    const savedViewMode = localStorage.getItem('viewMode');
    return savedViewMode ? savedViewMode : 'table';
  } catch (error) {
    console.error('Error reading view mode from localStorage:', error);
    return 'table';
  }
};

const getInitialFilters = () => {
  try {
    const savedFilters = localStorage.getItem('viewFilters');
    return savedFilters ? JSON.parse(savedFilters) : {};
  } catch (error) {
    console.error('Error reading view filters from localStorage:', error);
    return {};
  }
};

const viewSlice = createSlice({
  name: 'view',
  initialState: {
    viewMode: getInitialViewMode(),
    viewPreferences: {},
    filters: getInitialFilters()
  },
  reducers: {
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
      // Save to localStorage when view mode changes
      try {
        localStorage.setItem('viewMode', action.payload);
      } catch (error) {
        console.error('Error saving view mode to localStorage:', error);
      }
    },
    
    // For future use - save component-specific view settings
    setComponentViewPreference: (state, action) => {
      const { component, preference } = action.payload;
      state.viewPreferences[component] = preference;
      
      // Save component-specific preferences to localStorage
      try {
        localStorage.setItem('viewPreferences', JSON.stringify(state.viewPreferences));
      } catch (error) {
        console.error('Error saving view preferences to localStorage:', error);
      }
    },

    // Project Manager Filter Actions
    setProjectManagerFilter: (state, action) => {
      const { page, projectManager } = action.payload;
      state.filters[page] = {
        ...state.filters[page],
        selectedProjectManager: projectManager
      };
      
      // Save filters to localStorage
      try {
        localStorage.setItem('viewFilters', JSON.stringify(state.filters));
      } catch (error) {
        console.error('Error saving view filters to localStorage:', error);
      }
    },

    clearProjectManagerFilter: (state, action) => {
      const { page } = action.payload;
      if (state.filters[page]) {
        delete state.filters[page].selectedProjectManager;
        
        // Clean up empty filter objects
        if (Object.keys(state.filters[page]).length === 0) {
          delete state.filters[page];
        }
      }
      
      // Save filters to localStorage
      try {
        localStorage.setItem('viewFilters', JSON.stringify(state.filters));
      } catch (error) {
        console.error('Error saving view filters to localStorage:', error);
      }
    }
  }
});

export const { 
  setViewMode, 
  setComponentViewPreference, 
  setProjectManagerFilter, 
  clearProjectManagerFilter 
} = viewSlice.actions;
export default viewSlice.reducer; 